document.addEventListener('DOMContentLoaded', function () {

    document.addEventListener('wpcf7submit', function (event) {
        unlockButton(event.target);
    });

    document.addEventListener('wpcf7invalid', function (event) {
        unlockButton(event.target);
    });

    document.addEventListener('wpcf7spam', function (event) {
        unlockButton(event.target);
    });

    document.addEventListener('wpcf7mailfailed', function (event) {
        unlockButton(event.target);
    });

    document.querySelectorAll('.wpcf7-form').forEach(function (form) {
        form.addEventListener('submit', function () {
            lockButton(form);
        });
    });

    function lockButton(form) {
        let btn = form.querySelector('.wpcf7-submit');
        if (!btn || btn.classList.contains('is-sending')) return;
        btn.disabled = true;
        btn.classList.add('is-sending');
    }

    function unlockButton(form) {
        let btn = form.querySelector('.wpcf7-submit');
        if (!btn) return;
        btn.disabled = false;
        btn.classList.remove('is-sending');
    }

});